import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form, Divider, Space, InputNumber } from "antd";
import RentImageList, { RentImageType } from "./RentImageList";
import RentImageList2, { RentImageType2 } from "./RentImageList2";
import { useAsyncAxios, utilAxiosFormWithAuth } from "../utils/customAxios";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";

import styles from "../pages/RentManagement/ReservationManagement.module.css";

function RentImageViewer({
    rent,
    onChangeRentBattery,
}: {
    rent?: Types.RentDto;
    onChangeRentBattery?: (rent: Types.RentDto, startSoc: number | null, endSoc: number | null) => void;
}) {
    const [currentRent, setCurrentRent] = useState<Types.RentDto>();

    const [editModeStartManagerImage, setEditModeStartManagerImage] = useState(false);
    const [startManagerImage, setStartManagerImage] = useState<RentImageType>();
    const [startManagerAdditionalImage, setStartManagerAdditionalImage] = useState<RentImageType2>();

    const [editModeEndManagerImage, setEditModeEndManagerImage] = useState(false);
    const [endManagerImage, setEndManagerImage] = useState<RentImageType>();
    const [endManagerAdditionalImage, setEndManagerAdditionalImage] = useState<RentImageType2>();

    const [resetImages, setResetImages] = useState({});

    const [tempStartBatterySoc, setTempStartBatterySoc] = useState<number | null>(null);
    const [tempEndBatterySoc, setTempEndBatterySoc] = useState<number | null>(null);

    useEffect(() => {
        setCurrentRent(rent);

        if (rent?.startBatterySoc) {
            setTempStartBatterySoc(rent?.startBatterySoc);
        } else setTempStartBatterySoc(null);
        if (rent?.endBatterySoc) {
            setTempEndBatterySoc(rent?.endBatterySoc);
        } else setTempEndBatterySoc(null);
    }, [rent]);

    useEffect(() => {
        setEditModeStartManagerImage(false);
        setEditModeEndManagerImage(false);
    }, [currentRent]);

    const requestAxiosGetRent = async (rentId: number) => {
        const response = await utilAxiosFormWithAuth().get(Request.RENT_URL + rentId);

        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setCurrentRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;

        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    const requestAxiosAddImages = async (url: string, image: RentImageType) => {
        const response = await utilAxiosFormWithAuth().post(url, image, {
            params: { imageUploader: "MANAGER" },
        });

        return response.data;
    };

    const {
        loading: loadingAddImages,
        error: errorAddImages,
        data: resultAddImages,
        execute: requestAddImages,
    } = useAsyncAxios(requestAxiosAddImages);

    useEffect(() => {
        if (resultAddImages === null) return;
        console.log("resultAddImages", resultAddImages);
        requestGetRent(currentRent?.rentId);
    }, [resultAddImages]);

    useEffect(() => {
        if (errorAddImages === null) return;

        console.log("errorAddImages", errorAddImages);
    }, [errorAddImages]);

    const checkSaveImages = (images: RentImageType | undefined) => {
        if (images === undefined) return false;

        if (
            images.front === undefined ||
            images.left === undefined ||
            images.back === undefined ||
            images.right === undefined ||
            images.cluster === undefined
        )
            return false;

        return true;
    };

    const onSaveImage = (type: string) => {
        let saveImage: RentImageType | RentImageType2 | undefined;
        let requestUrl;
        if (type === "START") {
            saveImage = startManagerImage;
            requestUrl = Request.RENT_URL + currentRent?.rentId + Request.RENT_IMAGE_ADD_START_URL;

            if (checkSaveImages(saveImage) === false) {
                Modal.error({
                    title: "출차이미지 오류",
                    content: "필수 이미지를 넣으세요.",
                    okText: "확인",
                    onOk() {},
                    centered: true,
                });

                return;
            }

            if (saveImage !== undefined && startManagerAdditionalImage !== undefined && startManagerAdditionalImage.rentImages.length > 0) {
                saveImage.additionalImages = startManagerAdditionalImage.rentImages;
            }

            if (saveImage === undefined) return;

            const formData = new FormData();
            saveImage.front && formData.append("front", saveImage.front);
            saveImage.left && formData.append("left", saveImage.left);
            saveImage.back && formData.append("back", saveImage.back);
            saveImage.right && formData.append("right", saveImage.right);
            saveImage.cluster && formData.append("cluster", saveImage.cluster);
            saveImage.additionalImages?.forEach((file) => formData.append("additionalImages", file));

            requestAddImages(requestUrl, formData);
        } else if (type === "END") {
            // saveImage = endManagerImage;
            // requestUrl = Request.RENT_URL + currentRent?.rentId + Request.RENT_IMAGE_ADD_END_URL;

            // if (saveImage?.rentImages.length === 0) {
            //     Modal.error({
            //         title: "반납이미지 오류",
            //         content: "이미지를 넣으세요.",
            //         okText: "확인",
            //         onOk() {},
            //         centered: true,
            //     });
            //     return;
            // }

            // const formData = new FormData();
            // endManagerImage?.rentImages.forEach((file) => formData.append("rentImages", file));

            // requestAddImages(requestUrl, formData);
            saveImage = endManagerImage;
            requestUrl = Request.RENT_URL + currentRent?.rentId + Request.RENT_IMAGE_ADD_END_URL;

            if (checkSaveImages(saveImage) === false) {
                Modal.error({
                    title: "반납이미지 오류",
                    content: "필수 이미지를 넣으세요.",
                    okText: "확인",
                    onOk() {},
                    centered: true,
                });

                return;
            }

            if (saveImage !== undefined && endManagerAdditionalImage !== undefined && endManagerAdditionalImage.rentImages.length > 0) {
                saveImage.additionalImages = endManagerAdditionalImage.rentImages;
            }

            if (saveImage === undefined) return;

            const formData = new FormData();
            saveImage.front && formData.append("front", saveImage.front);
            saveImage.left && formData.append("left", saveImage.left);
            saveImage.back && formData.append("back", saveImage.back);
            saveImage.right && formData.append("right", saveImage.right);
            saveImage.cluster && formData.append("cluster", saveImage.cluster);
            saveImage.additionalImages?.forEach((file) => formData.append("additionalImages", file));

            requestAddImages(requestUrl, formData);
        }
    };

    const onDeleteImage = (rentImageId: number) => {
        Modal.confirm({
            title: "이미지 삭제",
            content: "이미지를 삭제하시겠습니까?",
            okText: "확인",
            onOk() {
                requestDeleteImage(rentImageId);
            },
            cancelText: "취소",
            onCancel() {
                setResetImages({});
            },
            centered: true,
        });
    };

    const requestAxiosDeleteImage = async (rentImageId: number) => {
        const response = await utilAxiosFormWithAuth().delete(Request.RENT_IMAGE_URL + rentImageId);

        return response.data;
    };

    const {
        loading: loadingDeleteImage,
        error: errorDeleteImage,
        data: resultDeleteImage,
        execute: requestDeleteImage,
    } = useAsyncAxios(requestAxiosDeleteImage);

    useEffect(() => {
        if (resultDeleteImage === null) return;
        console.log("resultDeleteImage", resultDeleteImage);
        requestGetRent(currentRent?.rentId);
    }, [resultDeleteImage]);

    useEffect(() => {
        if (errorDeleteImage === null) return;

        console.log("errorDeleteImage", errorDeleteImage);
    }, [errorDeleteImage]);

    return (
        <>
            {currentRent && (
                <>
                    <div>
                        <Row justify={"space-between"}>
                            <Col span={6}>
                                <Divider className={styles.subTitle} orientation="left">
                                    <span>차량 상태</span>
                                </Divider>
                            </Col>
                        </Row>

                        <Form>
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                    <Form.Item className="searchForm searchLastRow" name="startBatterySoc" label="출차 배터리 상태">
                                        <Space>
                                            <InputNumber
                                                placeholder="출차 배터리량"
                                                value={tempStartBatterySoc}
                                                onChange={(value) => setTempStartBatterySoc(value)}
                                            ></InputNumber>
                                            <span>%</span>
                                            <Button
                                                onClick={() =>
                                                    onChangeRentBattery && onChangeRentBattery(currentRent, tempStartBatterySoc, tempEndBatterySoc)
                                                }
                                            >
                                                수정
                                            </Button>
                                        </Space>
                                        {/* <span>{rent?.startBatterySoc ? rent.startBatterySoc + "%" : String.dash}</span> */}
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                    <Form.Item className="searchForm searchLastRow" name="endBatterySoc" label="도착 배터리 상태">
                                        <Space>
                                            <InputNumber
                                                placeholder="반납 배터리량"
                                                value={tempEndBatterySoc}
                                                onChange={(value) => setTempEndBatterySoc(value)}
                                            ></InputNumber>
                                            <span>%</span>
                                            <Button
                                                onClick={() =>
                                                    onChangeRentBattery && onChangeRentBattery(currentRent, tempStartBatterySoc, tempEndBatterySoc)
                                                }
                                            >
                                                수정
                                            </Button>
                                        </Space>
                                        {/* <span>{rent?.endBatterySoc ? rent.endBatterySoc + "%" : String.dash}</span> */}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {/*<div>
                        <Row justify={"space-between"}>
                            <Col span={6}>
                                <Divider className={styles.subTitle} orientation="left">
                                    <span>출차 사진</span>
                                </Divider>
                            </Col>
                            <Col>
                                {editModeStartManagerImage ? (
                                    <Space>
                                        <Button
                                            onClick={() => {
                                                setResetImages({});
                                                setEditModeStartManagerImage(false);
                                            }}
                                        >
                                            {String.prev}
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                onSaveImage("START");
                                                setEditModeStartManagerImage(false);
                                            }}
                                        >
                                            {String.update}
                                        </Button>
                                    </Space>
                                ) : (
                                    <Button onClick={() => setEditModeStartManagerImage(true)}>{String.edit}</Button>
                                )}
                            </Col>
                        </Row>

                        <Row style={{ width: "100%" }}>
                            <Col xs={{ span: 24 }} >
                                <Form.Item className="searchForm" name="endDate" label="출차사진 (관리자)">
                                    <RentImageList
                                        rentInputImages={currentRent.rentImages.filter(
                                            (image) => image.imageUploader === "MANAGER" && image.uploadTiming === "START" && image.direction !== null
                                        )}
                                        inputType={editModeStartManagerImage}
                                        resetImage={resetImages}
                                        onImageListChanged={(imageList) => setStartManagerImage(imageList)}
                                        onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
                                    />
                                    <RentImageList2
                                        rentInputImages={currentRent.rentImages.filter(
                                            (image) => image.imageUploader === "MANAGER" && image.uploadTiming === "START" && image.direction === null
                                        )}
                                        inputType={editModeStartManagerImage}
                                        resetImage={resetImages}
                                        onImageListChanged={(imageList) => {
                                            const images: RentImageType2 = { rentImages: [] };
                                            imageList.forEach((image) => image.file && images.rentImages.push(image.file));
                                            setStartManagerAdditionalImage(images);
                                        }}
                                        onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ width: "100%" }}>
                            <Col xs={{ span: 24 }} >
                                <Form.Item className="searchForm" name="endDate" label="출차사진 (사용자)">
                                    <RentImageList
                                        rentInputImages={currentRent.rentImages.filter(
                                            (image) => image.imageUploader === "USER" && image.uploadTiming === "START"
                                        )}
                                        inputType={false}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>*/}
                </>
            )}

            {/*currentRent && (
                <div>
                    <Row justify={"space-between"}>
                        <Col span={6}>
                            <Divider className={styles.subTitle} orientation="left">
                                <span>반납 사진</span>
                            </Divider>
                        </Col>
                        <Col>
                            {editModeEndManagerImage ? (
                                <Space>
                                    <Button
                                        onClick={() => {
                                            setResetImages({});
                                            setEditModeEndManagerImage(false);
                                        }}
                                    >
                                        {String.prev}
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            onSaveImage("END");
                                            setEditModeEndManagerImage(false);
                                        }}
                                    >
                                        {String.update}
                                    </Button>
                                </Space>
                            ) : (
                                <Button onClick={() => setEditModeEndManagerImage(true)}>{String.edit}</Button>
                            )}
                        </Col>
                    </Row>

                    <Row style={{ width: "100%" }}>
                        <Col xs={{ span: 24 }} >
                            <Form.Item className="searchForm" name="endDate" label="반납사진 (관리자)">
                                <RentImageList
                                    rentInputImages={currentRent.rentImages.filter(
                                        (image) => image.imageUploader === "MANAGER" && image.uploadTiming === "END" && image.direction !== null
                                    )}
                                    inputType={editModeEndManagerImage}
                                    resetImage={resetImages}
                                    onImageListChanged={(imageList) => setEndManagerImage(imageList)}
                                    onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
                                />
                                <RentImageList2
                                    rentInputImages={currentRent.rentImages.filter(
                                        (image) => image.imageUploader === "MANAGER" && image.uploadTiming === "END" && image.direction === null
                                    )}
                                    inputType={editModeEndManagerImage}
                                    resetImage={resetImages}
                                    onImageListChanged={(imageList) => {
                                        const images: RentImageType2 = { rentImages: [] };
                                        imageList.forEach((image) => image.file && images.rentImages.push(image.file));
                                        setEndManagerAdditionalImage(images);
                                    }}
                                    onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                        <Col xs={{ span: 24 }} >
                            <Form.Item className="searchForm searchLastRow" name="endDate" label="반납사진 (사용자)">
                                <RentImageList
                                    rentInputImages={currentRent.rentImages.filter(
                                        (image) => image.imageUploader === "USER" && image.uploadTiming === "END"
                                    )}
                                    inputType={false}
                                    resetImage={resetImages}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            )*/}
        </>
    );
}

export default RentImageViewer;
